import { UiFloatModal } from "../../../common/modal/index.js"
import { MSDataTree } from "../../../tree/tree.js";

const template = (expandedLevel) => `
    <ms-tree idfield="ItemPath" filter='{"AccessTrend":true}' autoselect="true" horizontalalign="1" verticalalign="1" sourcetype="0" multiselect="true" expanded="false" expandedlevel="${expandedLevel}" displayfield="Name" proportiontype="4" style="box-sizing: border-box; display: flex; overflow: hidden; position: relative; z-index: 2; width: 100%; height: 480px; background-color: rgb(245, 240, 245);">
    </ms-tree>
    <div>
        <button style="width: 50%;height: 2em;" class="ms update">${i18next.t("apply")}</button><button style="width: 50%;height: 2em;" class="ms close">${i18next.t("cancel")}</button>
    </div>
`

export class SelectTree {
    constructor(root) {
        this.root = root
        this.state = this.root.state
        if (typeof window.customElements.get("ms-tree") === "undefined") {
            window.customElements.define("ms-tree", MSDataTree);
        }
    }

    CreateWin(title, expandedLevel) {
        const currentGroup = this.state.groups.find(g => g.id === this.state.selectedGroup)
        this.modal = new UiFloatModal(template(expandedLevel))
        if(!this.root.parentHasPopup) this.modal.root.style.zIndex = 10000100;
        this.modal.modalComponent.calculateInitialPosition = () => {
            const { top, left } = this.root.root.getBoundingClientRect()
            return [left, top]
        }
        this.modal.modalComponent.label = title ? `${i18next.t("trend_objectTree_title")} - ${title} ${currentGroup.selected.length}/${this.root.penmaxammount}` : this._type ? i18next.t("trend_objectTree_title_obj") : i18next.t("trend_objectTree_title");
        
        this.tree = this.modal.modalComponent.querySelector("ms-tree");
        this.tree.onChange = this.onTreeChange.bind(this)
        if (this.filter) this.tree.filtercallback = this.filter;
        this.tree.rootitem = this.rootitem;

        this.modal.modalComponent.querySelector(".update").onclick = (e) => {
            this.modal.modalComponent.close();
            this.onUpdate(this.selected);
        };

        this.modal.modalComponent.querySelector(".close").onclick = (e) => {
            if (!this.selected.length && !this.group.selected.length) {
                this.root.state.groups = this.root.state.groups.filter(item => item.id !== this.group.id)
                this.root.groups.values = this.root.state.groups
            }
            this.modal.modalComponent.close();
        };
    }

    onTreeChange(selected) {
        const currentGroup = this.state.groups.find(g => g.id === this.state.selectedGroup)
        this.modal.modalComponent.title = `${i18next.t("trend_objectTree_title")} - ${currentGroup.name} ${selected.length}/${this.root.penmaxammount}`
    }

    Open(title, expandedLevel, selected = []) {
        if (!this.modal) {
            this.modal = null;
            this.CreateWin(title, expandedLevel);
        }
        this.tree.values = selected;
        this.tree.afterInitialize();
        this.modal.modalComponent.open();
    }

    get onUpdate() {
        return this._callback;
    }
    set onUpdate(value) {
        this._callback = value;
    }

    get group() {
        return this._group;
    }
    set group(value) {
        this._group = value;
    }

    get selected() {
        return this.tree.values
    }
    set selected(value) {
        this.tree.values = value;
    }

    get rootitem() {
        return this._rootitem;
    }
    set rootitem(v) {
        this._rootitem = v;
    }
    /**
     * Тренд
     * @type {string}
     */
    get trend() {
        return this._trend;
    }
    set trend(value) {
        this._trend = value;
        if (typeof value !== "object") {
            let ms = this.parentElement;
            while (ms.nodeName !== "MS-WINDOW") {
                ms = ms.parentElement;
            }
            if (value) {
                if (this._trendControl)
                    this._trendControl.removeObserver(this.__reciver);

                this._trendControl = ms.querySelector(`[id="${value}"]`);

                this._trendControl.addObserver(this.__reciver);
            }
        } else {
            this._trendControl = value;
        }
    }

    dispose() {
        this.filter = null;
        this.tree = null;
        this.modal = null;
    }
}